import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = false;

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startLoading: () => true,
    stopLoading: () => false,
  },
});

// Action creators are generated for each case reducer function
export const { startLoading, stopLoading } = loaderSlice.actions;

export const getLoadingState = (state: RootState) => state.loader;

export default loaderSlice.reducer;
